import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center gap-4"
}
const _hoisted_2 = { class: "h-20 w-20 flex-shrink-0 overflow-hidden rounded-lg bg-gray-800" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex flex-1 items-center justify-between" }
const _hoisted_5 = { class: "space-y-1 min-w-0 max-w-[500px]" }
const _hoisted_6 = { class: "font-medium text-gray-100 line-clamp-2" }
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = { class: "text-sm text-gray-400" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-wrap gap-1"
}
const _hoisted_10 = { class: "flex items-center gap-4" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = { class: "relative flex h-2 w-2" }
const _hoisted_13 = { class: "inline-flex items-center gap-1 rounded-full bg-gray-700/50 px-2 py-0.5 text-xs font-medium text-gray-300" }
const _hoisted_14 = { class: "flex items-center gap-3" }
const _hoisted_15 = { class: "absolute -top-2 -right-2" }
const _hoisted_16 = {
  key: 0,
  class: "flex h-3 w-3"
}
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "w-[72px]" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "h-4 w-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_22 = { class: "relative group" }
const _hoisted_23 = ["aria-checked", "disabled", "title"]
const _hoisted_24 = {
  key: 0,
  class: "absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:block z-10"
}
const _hoisted_25 = {
  key: 1,
  class: "flex h-full flex-col"
}
const _hoisted_26 = { class: "relative aspect-square w-full overflow-hidden bg-gray-800" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { class: "absolute right-2 top-2 flex flex-col gap-1" }
const _hoisted_29 = { class: "inline-flex items-center gap-1 rounded-full bg-gray-900/80 px-2 py-0.5 text-xs font-medium text-gray-300 shadow-sm backdrop-blur-sm" }
const _hoisted_30 = { class: "flex flex-1 flex-col p-4" }
const _hoisted_31 = { class: "mb-3 flex-1 min-w-0" }
const _hoisted_32 = { class: "font-medium text-gray-100 line-clamp-2" }
const _hoisted_33 = { class: "mt-1 flex items-center gap-2" }
const _hoisted_34 = { class: "text-sm text-gray-400" }
const _hoisted_35 = {
  key: 0,
  class: "mb-3 flex flex-wrap gap-1"
}
const _hoisted_36 = { class: "flex items-center justify-between border-t border-gray-700 pt-3" }
const _hoisted_37 = { class: "flex items-center gap-3" }
const _hoisted_38 = { class: "absolute -top-2 -right-2" }
const _hoisted_39 = {
  key: 0,
  class: "flex h-3 w-3"
}
const _hoisted_40 = { class: "relative" }
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "w-[72px]" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 0,
  class: "h-4 w-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_45 = ["aria-checked", "disabled", "title"]

import { ref, computed } from 'vue'
import { useProductStore } from '@/stores/products'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductListItem',
  props: {
    product: {},
    isGrid: { type: Boolean }
  },
  emits: ["edit-meta-prompt"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const productStore = useProductStore()
const isAvailable = computed(() => (props.product.inventory_qty ?? 0) > 0)
const priority = ref(props.product.config?.priority ?? 0)

const isShopifyInactive = computed(() => {
  return ['DRAFT', 'ARCHIVED'].includes(props.product.shopify_status)
})

const updatePriority = async () => {
  await productStore.updateProduct(props.product.id, {
    config: {
      ...props.product.config,
      priority: priority.value
    }
  })
}

const toggleActive = async () => {
  if (isShopifyInactive.value) return
  
  await productStore.updateProduct(props.product.id, {
    config: {
      ...props.product.config,
      is_active: !props.product.config?.is_active
    }
  })
}

const saveProduct = async () => {
  try {
    await productStore.saveProduct(props.product.id)
  } catch (error) {
    // Handle error (you might want to show a notification)
    console.error('Failed to save product:', error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'group relative transition-all duration-200',
      _ctx.isGrid 
        ? 'overflow-hidden rounded-lg border border-gray-700 bg-dark hover:border-primary' 
        : 'border-b border-x-0 border-t-0 border-gray-700 last:border-b-0 px-4 py-3',
      !_ctx.isGrid && !_ctx.product.config?.is_active ? 'opacity-60' : ''
    ])
  }, [
    (!_ctx.isGrid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.product.image,
              alt: _ctx.product.title,
              class: "h-full w-full object-cover"
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.product.title), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.product.product_type), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium", {
                  'bg-gray-500/20 text-gray-400': _ctx.product.shopify_status === 'DRAFT',
                  'bg-red-500/20 text-red-400': _ctx.product.shopify_status === 'ARCHIVED'
                }])
                }, _toDisplayString((_ctx.product.shopify_status || '').toLowerCase()), 3)
              ]),
              (_ctx.product.tags?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.tags, (tag) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: tag,
                        class: "inline-flex items-center rounded-full bg-gray-700/50 px-2 py-0.5 text-xs text-gray-300"
                      }, _toDisplayString(tag), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", {
                  class: _normalizeClass([
              'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
              isAvailable.value ? 'bg-emerald-500/20 text-emerald-500' : 'bg-red-500/20 text-red-500'
            ])
                }, [
                  _createElementVNode("span", _hoisted_12, [
                    _createElementVNode("span", {
                      class: _normalizeClass([
                  'absolute inline-flex h-full w-full animate-ping rounded-full opacity-75',
                  isAvailable.value ? 'bg-emerald-500' : 'bg-red-500'
                ])
                    }, null, 2),
                    _createElementVNode("span", {
                      class: _normalizeClass([
                  'relative inline-flex h-2 w-2 rounded-full',
                  isAvailable.value ? 'bg-emerald-500' : 'bg-red-500'
                ])
                    }, null, 2)
                  ]),
                  _createTextVNode(" " + _toDisplayString(isAvailable.value ? 'Available' : 'Out of Stock'), 1)
                ], 2),
                _createElementVNode("span", _hoisted_13, [
                  _cache[4] || (_cache[4] = _createElementVNode("svg", {
                    class: "h-3 w-3",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.product.inventory_qty) + " in stock ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit-meta-prompt'))),
                  class: _normalizeClass(["group/meta relative rounded-lg border border-gray-700 p-1.5 text-gray-400 hover:border-primary hover:text-primary", {'border-primary/30 bg-primary/10 text-primary': _ctx.product.config?.meta_prompt}])
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    class: "w-5 h-5"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                    })
                  ], -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sr-only" }, "Edit Meta Prompt", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.product.config?.meta_prompt)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _cache[5] || (_cache[5] = [
                          _createElementVNode("span", { class: "relative inline-flex rounded-full h-3 w-3 bg-primary" }, null, -1)
                        ])))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((priority).value = $event)),
                    onChange: updatePriority,
                    class: "w-16 rounded border border-gray-700 bg-dark px-2 py-1 text-sm text-gray-100",
                    min: "0",
                    title: 'Priority: ' + priority.value
                  }, null, 40, _hoisted_18), [
                    [_vModelText, priority.value]
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "absolute -top-5 right-0 text-xs text-gray-400 whitespace-nowrap" }, " Priority ", -1))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("button", {
                    onClick: saveProduct,
                    disabled: _ctx.product.isSaving,
                    class: _normalizeClass(["inline-flex h-[30px] w-[72px] items-center justify-center gap-1 rounded-lg border text-sm font-medium transition-all", [
                  _ctx.product.isSaving
                    ? 'border-gray-700 bg-gray-800 text-gray-400'
                    : 'border-primary bg-primary/10 text-primary hover:bg-primary/20'
                ]])
                  }, [
                    (_ctx.product.isSaving)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_21, _cache[9] || (_cache[9] = [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }, null, -1),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.product.isSaving ? 'Saving' : 'Save'), 1)
                  ], 10, _hoisted_20), [
                    [_vShow, _ctx.product.isDirty]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    onClick: toggleActive,
                    class: _normalizeClass(["relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none", [
                isShopifyInactive.value ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
                _ctx.product.config?.is_active ? 'bg-emerald-500' : 'bg-gray-700'
              ]]),
                    role: "switch",
                    "aria-checked": _ctx.product.config?.is_active,
                    disabled: isShopifyInactive.value,
                    title: isShopifyInactive.value ? 'Please make product active in Shopify to enable' : (_ctx.product.config?.is_active ? 'Active in search' : 'Inactive in search')
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out", [
                  _ctx.product.config?.is_active ? 'translate-x-5' : 'translate-x-0'
                ]])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["absolute inset-0 flex h-full w-full items-center justify-center transition-opacity", [
                    _ctx.product.config?.is_active ? 'opacity-0 duration-100 ease-out' : 'opacity-100 duration-200 ease-in'
                  ]]),
                        "aria-hidden": "true"
                      }, _cache[10] || (_cache[10] = [
                        _createElementVNode("svg", {
                          class: "h-3 w-3 text-gray-400",
                          fill: "none",
                          viewBox: "0 0 12 12"
                        }, [
                          _createElementVNode("path", {
                            d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ], -1)
                      ]), 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(["absolute inset-0 flex h-full w-full items-center justify-center transition-opacity", [
                    _ctx.product.config?.is_active ? 'opacity-100 duration-200 ease-in' : 'opacity-0 duration-100 ease-out'
                  ]]),
                        "aria-hidden": "true"
                      }, _cache[11] || (_cache[11] = [
                        _createElementVNode("svg", {
                          class: "h-3 w-3 text-emerald-500",
                          fill: "currentColor",
                          viewBox: "0 0 12 12"
                        }, [
                          _createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
                        ], -1)
                      ]), 2)
                    ], 2)
                  ], 10, _hoisted_23),
                  (isShopifyInactive.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[12] || (_cache[12] = [
                        _createElementVNode("div", { class: "bg-dark-secondary text-xs text-gray-300 rounded-md px-2 py-1 whitespace-nowrap border border-gray-700" }, [
                          _createTextVNode(" Product must be activated in Shopify "),
                          _createElementVNode("div", { class: "absolute top-full left-1/2 -translate-x-1/2 -mt-px border-4 border-transparent border-t-gray-700" })
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("img", {
              src: _ctx.product.image,
              alt: _ctx.product.title,
              class: _normalizeClass([
            'h-full w-full object-cover transition-opacity duration-200',
            !_ctx.product.config?.is_active ? 'opacity-40' : ''
          ])
            }, null, 10, _hoisted_27),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", {
                class: _normalizeClass([
            'inline-flex items-center justify-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium shadow-sm min-w-[90px]',
            isAvailable.value ? 'bg-emerald-500 text-white' : 'bg-red-500 text-white'
          ])
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "relative flex h-2 w-2" }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([
                'absolute inline-flex h-full w-full animate-ping rounded-full opacity-75 bg-white'
              ])
                  }),
                  _createElementVNode("span", {
                    class: _normalizeClass([
                'relative inline-flex h-2 w-2 rounded-full bg-white'
              ])
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(isAvailable.value ? 'Available' : 'Out of Stock'), 1)
              ], 2),
              _createElementVNode("span", _hoisted_29, [
                _cache[14] || (_cache[14] = _createElementVNode("svg", {
                  class: "h-3 w-3",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.product.inventory_qty) + " in stock ", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.product.title), 1),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.product.product_type), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium", {
                  'bg-gray-500/20 text-gray-400': _ctx.product.shopify_status === 'DRAFT',
                  'bg-red-500/20 text-red-400': _ctx.product.shopify_status === 'ARCHIVED'
                }])
                }, _toDisplayString((_ctx.product.shopify_status || '').toLowerCase()), 3)
              ])
            ]),
            (_ctx.product.tags?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: tag,
                      class: "inline-flex items-center rounded-full bg-gray-700/50 px-2 py-0.5 text-xs text-gray-300"
                    }, _toDisplayString(tag), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('edit-meta-prompt'))),
                  class: _normalizeClass(["group/meta relative rounded-lg border border-gray-700 p-1.5 text-gray-400 hover:border-primary hover:text-primary", {'border-primary/30 bg-primary/10 text-primary': _ctx.product.config?.meta_prompt}])
                }, [
                  _cache[16] || (_cache[16] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    class: "w-5 h-5"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                    })
                  ], -1)),
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "sr-only" }, "Edit Meta Prompt", -1)),
                  _createElementVNode("div", _hoisted_38, [
                    (_ctx.product.config?.meta_prompt)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, _cache[15] || (_cache[15] = [
                          _createElementVNode("span", { class: "relative inline-flex rounded-full h-3 w-3 bg-primary" }, null, -1)
                        ])))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_40, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((priority).value = $event)),
                    onChange: updatePriority,
                    class: "w-16 rounded border border-gray-700 bg-dark px-2 py-1 text-sm text-gray-100",
                    min: "0",
                    title: 'Priority: ' + priority.value
                  }, null, 40, _hoisted_41), [
                    [_vModelText, priority.value]
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("span", { class: "absolute -top-5 left-0 text-xs text-gray-400 whitespace-nowrap" }, " Priority ", -1))
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("button", {
                    onClick: saveProduct,
                    disabled: _ctx.product.isSaving,
                    class: _normalizeClass(["inline-flex h-[30px] w-[72px] items-center justify-center gap-1 rounded-lg border text-sm font-medium transition-all", [
                  _ctx.product.isSaving
                    ? 'border-gray-700 bg-gray-800 text-gray-400'
                    : 'border-primary bg-primary/10 text-primary hover:bg-primary/20'
                ]])
                  }, [
                    (_ctx.product.isSaving)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_44, _cache[19] || (_cache[19] = [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }, null, -1),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.product.isSaving ? 'Saving' : 'Save'), 1)
                  ], 10, _hoisted_43), [
                    [_vShow, _ctx.product.isDirty]
                  ])
                ])
              ]),
              _createElementVNode("button", {
                onClick: toggleActive,
                class: _normalizeClass(["relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none", [
              isShopifyInactive.value ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
              _ctx.product.config?.is_active ? 'bg-emerald-500' : 'bg-gray-700'
            ]]),
                role: "switch",
                "aria-checked": _ctx.product.config?.is_active,
                disabled: isShopifyInactive.value,
                title: isShopifyInactive.value ? 'Please make product active in Shopify to enable' : (_ctx.product.config?.is_active ? 'Active in search' : 'Inactive in search')
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out", [
                _ctx.product.config?.is_active ? 'translate-x-5' : 'translate-x-0'
              ]])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["absolute inset-0 flex h-full w-full items-center justify-center transition-opacity", [
                  _ctx.product.config?.is_active ? 'opacity-0 duration-100 ease-out' : 'opacity-100 duration-200 ease-in'
                ]]),
                    "aria-hidden": "true"
                  }, _cache[20] || (_cache[20] = [
                    _createElementVNode("svg", {
                      class: "h-3 w-3 text-gray-400",
                      fill: "none",
                      viewBox: "0 0 12 12"
                    }, [
                      _createElementVNode("path", {
                        d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ], -1)
                  ]), 2),
                  _createElementVNode("span", {
                    class: _normalizeClass(["absolute inset-0 flex h-full w-full items-center justify-center transition-opacity", [
                  _ctx.product.config?.is_active ? 'opacity-100 duration-200 ease-in' : 'opacity-0 duration-100 ease-out'
                ]]),
                    "aria-hidden": "true"
                  }, _cache[21] || (_cache[21] = [
                    _createElementVNode("svg", {
                      class: "h-3 w-3 text-emerald-500",
                      fill: "currentColor",
                      viewBox: "0 0 12 12"
                    }, [
                      _createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
                    ], -1)
                  ]), 2)
                ], 2)
              ], 10, _hoisted_45)
            ])
          ])
        ]))
  ], 2))
}
}

})